/* ==========================================================================
   diXed · Variantenwahl auf der Produktseite
   Angelegt 31.08.2026, ueberarbeitet am selben Tag nach Ronnys Ansage.

   Zwei Aufgaben:
   1. Aus den Farbknoepfen werden Kacheln mit dem echten Variantenbild.
   2. "Color" und "Size" werden deutsch. Das steht bewusst im Theme und
      nicht in den Produktdaten: eine Neuanlage durch Spreadconnect wuerde
      eine Korrektur in den Daten wieder ueberschreiben, das Theme nicht.

   DREI ENTSCHEIDUNGEN, die sonst wie Willkuer aussehen:

   1. KEIN RUECKFALL AUF TEXTKNOEPFE. Ansage Ronny am 31.08.2026. Geprueft
      wurde vorher ueber alle 186 Produkte: 1063 Farbwerte, davon null ohne
      Variantenbild. Sollte doch einmal eines fehlen, springt das Bild des
      Produkts ein. Es bleibt in jedem Fall eine Kachel.

   2. MutationObserver statt einmaligem Lauf. Dawn baut die Variantenwahl bei
      jeder Auswahl NEU auf, und dabei gehen unsere Klassen verloren. Genau
      das war der Fehler: nach dem Klick auf eine Farbkachel stand wieder
      "Navy/Weiss" als Text da. Beobachtet wird der Aufbau, nicht ein
      bestimmtes Ereignis, damit es auch nach einem Dawn-Update noch traegt.

   3. Die Zuordnung Farbe zu Bild kommt bei JEDEM Seitenaufbau frisch aus
      Liquid. Neue Produkte und neue Farben an Bestandsprodukten sind damit
      automatisch dabei, ohne dass hier etwas nachgezogen werden muss.
   ========================================================================== */

(function () {
  'use strict';

  var laeuft = false;

  function daten() {
    var el = document.querySelector('[data-dx-varianten]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function beschriftungen(d) {
    document.querySelectorAll('.product-form__input legend').forEach(function (legende) {
      legende.childNodes.forEach(function (knoten) {
        if (knoten.nodeType !== 3) return;
        var roh = knoten.nodeValue.trim();
        if (!roh) return;
        var deutsch = d.beschriftungen[roh.toLowerCase()];
        if (deutsch) knoten.nodeValue = knoten.nodeValue.replace(roh, deutsch);
      });
    });
  }

  function farbkacheln(d) {
    var gruppen = document.querySelectorAll('.product-form__input--pill');
    if (!gruppen.length) return;

    var gruppe = gruppen[d.farboption - 1];
    if (!gruppe) return;

    gruppe.querySelectorAll('label').forEach(function (label) {
      /* NICHT der Beschriftungstext. Dawn haengt dort ein unsichtbares
         "Variante ausverkauft oder nicht verfuegbar" an, aus "Schwarz" wird
         damit ein anderer Schluessel. Der saubere Wert steht im Eingabefeld. */
      var eingabe = document.getElementById(label.getAttribute('for'))
        || label.previousElementSibling;
      var wert = eingabe && eingabe.value
        ? eingabe.value
        : (label.textContent || '').trim();

      var quelle = d.bilder[wert] || d.rueckfall;
      if (!quelle) return;

      label.classList.add('dx-farbkachel');
      label.style.backgroundImage = 'url("' + quelle + '")';
      label.setAttribute('title', wert);

      /* Vergriffen wird sichtbar gemacht. Dawn streicht den Text durch, den
         die Kachel nicht zeigt, deshalb traegt sie ein eigenes Merkmal. */
      var weg = eingabe && (eingabe.disabled || eingabe.classList.contains('disabled'));
      label.classList.toggle('dx-farbkachel--weg', !!weg);
    });

    gruppe.classList.add('dx-farbgruppe');
  }

  function anwenden() {
    if (laeuft) return;
    var d = daten();
    if (!d) return;
    laeuft = true;
    try {
      beschriftungen(d);
      farbkacheln(d);
    } finally {
      laeuft = false;
    }
  }

  function beobachten() {
    var ziel = document.querySelector('product-info')
      || document.querySelector('.product__info-container');
    if (!ziel || !window.MutationObserver) return;

    new MutationObserver(function () {
      /* Nur nacharbeiten, wenn tatsaechlich eine unbehandelte Beschriftung
         aufgetaucht ist. Sonst loest jede eigene Aenderung die naechste
         Runde aus. */
      var offen = document.querySelector(
        '.product-form__input--pill label:not(.dx-farbkachel)'
      );
      if (offen) anwenden();
    }).observe(ziel, { childList: true, subtree: true });
  }

  function start() {
    anwenden();
    beobachten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
